import RedirectConstants from '../constants/RedirectConstants';

function redirect(url) {
  return {
    forceRedirectURL: url,
    type: RedirectConstants.REDIRECT
  };
}

export default {
  redirect
};
